import React from "react";
import { Link } from "react-router-dom";

const ICONS = {
  scripts: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    />
  ),
  videos: (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
    />
  ),
};

const COPY = {
  scripts: {
    title: "No scripts yet",
    body: "Start from Ideas. Pick a high-performing pattern in your brand's audience and take it to production with a script.",
  },
  videos: {
    title: "No videos yet",
    body: "Start from Ideas. Pick a high-performing pattern in your brand's audience and take it to production with a script and video.",
  },
};

/**
 * Empty state when a brand has no scripts or videos yet. Points users to Ideas.
 */
const ProductionEmptyState = ({ kind }) => {
  const copy = COPY[kind];

  return (
    <div className="text-center py-16">
      <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-theme-secondary flex items-center justify-center">
        <svg
          className="w-10 h-10 text-theme-text opacity-30"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {ICONS[kind]}
        </svg>
      </div>
      <h3 className="text-xl font-semibold text-theme-text mb-2">{copy.title}</h3>
      <p className="text-theme-text opacity-60 max-w-md mx-auto mb-6">{copy.body}</p>
      <Link
        to="/ideas/"
        className="inline-flex px-4 py-2 rounded-md bg-theme-primary text-theme-button hover:opacity-90"
        style={{ backgroundColor: "var(--theme-primary)", color: "var(--theme-button-text)" }}
      >
        Go to Ideas
      </Link>
    </div>
  );
};

export default ProductionEmptyState;
